import React, { Component } from 'react';
import SmallSpinner from './SmallSpinner';
import PropTypes from 'prop-types';

/**
 * @param {string} value - required
 * @param {Object} returnObj - required
 * @param {function} onChange - required
 * @param {react component} children - required
 */
class SelectWrapper extends Component {
	render() {
		return this.props.children ? this.selectComponent() : this.spinner(); 
	}
	
	selectComponent = () => {
		const { children, value } = this.props;
		return <div className="pt-select">
			<select 
				onChange = { this.onChange }
				value = { value }
			>
				{ children }
			</select>
		</div>
	}
	
	spinner() {
		return <SmallSpinner />
	}
	
	
	onChange = (e) => {
		const { returnObj } = this.props;
		const value = e.target.value;
		this.props.onChange(value, returnObj)
	}
}

SelectWrapper.propTypes = {
	value: PropTypes.string.isRequired,
	returnObj: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired
}

export default SelectWrapper


// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/SelectWrapper.js